import React, {ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

interface GuideCardProps {
    title: string;
    content?: ReactNode;
    containerClassName?: string;
    titleClassName?: string;
    contentClassName?: string;
}
const GuideCard: React.FC<GuideCardProps> = ({
    title,
    content,
    containerClassName,
    titleClassName,
    contentClassName,
}) => {
    const containerClass = twMerge(
        'flex flex-col w-full h-full rounded-[16px] outline outline-[2px] outline-white bg-white/70',
        containerClassName,
    );
    const titleClass = twMerge(
        'font-montserrat flex justify-center items-end rounded-t-[16px] text-white',
        titleClassName,
    );
    const contentClass = twMerge('font-montserrat font-bold flex-1 rounded-b-[16px] p-3 w-full', contentClassName);

    return (
        <div className={containerClass}>
            <div className={titleClass} style={{background: `linear-gradient(92deg, #0D46FF 0.87%, #28D8FF 102.89%)`}}>
                {title}
            </div>
            {content}
        </div>
    );
};

export default GuideCard;
